var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPicTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 106c29.271 0 53-23.729 53-53S82.271 0 53 0 0 23.729 0 53s23.729 53 53 53z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.875 26.458A53 53 0 0053.061 0L53 53l45.875-26.542z",
    fill: "#12B886"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#4155BC",
    strokeWidth: 4,
    d: "M53 50V32m2.014 19.26l30-17"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53 14a3 3 0 100-6 3 3 0 000 6zM11 56a3 3 0 100-6 3 3 0 000 6zm84 0a3 3 0 100-6 3 3 0 000 6zM53 98a3 3 0 100-6 3 3 0 000 6z",
    fill: "#9ED5DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 53a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0z",
    fill: "#4155BC",
    stroke: "#4155BC"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTA2IiBoZWlnaHQ9IjEwNiIgdmlld0JveD0iMCAwIDEwNiAxMDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUzIDEwNmMyOS4yNzEgMCA1My0yMy43MjkgNTMtNTNTODIuMjcxIDAgNTMgMCAwIDIzLjcyOSAwIDUzczIzLjcyOSA1MyA1MyA1M3oiIGZpbGw9IiNmZmYiLz48cGF0aCBkPSJNOTguODc1IDI2LjQ1OEE1MyA1MyAwIDAgMCA1My4wNjEgMEw1MyA1M2w0NS44NzUtMjYuNTQyeiIgZmlsbD0iIzEyQjg4NiIvPjxwYXRoIHN0cm9rZT0iIzQxNTVCQyIgc3Ryb2tlLXdpZHRoPSI0IiBkPSJNNTMgNTBWMzJNNTUuMDE0IDUxLjI2bDMwLTE3Ii8+PHBhdGggZD0iTTUzIDE0YTMgMyAwIDEgMCAwLTYgMyAzIDAgMCAwIDAgNnpNMTEgNTZhMyAzIDAgMSAwIDAtNiAzIDMgMCAwIDAgMCA2ek05NSA1NmEzIDMgMCAxIDAgMC02IDMgMyAwIDAgMCAwIDZ6TTUzIDk4YTMgMyAwIDEgMCAwLTYgMyAzIDAgMCAwIDAgNnoiIGZpbGw9IiM5RUQ1REIiLz48cGF0aCBkPSJNNTYuNSA1M2EzLjUgMy41IDAgMSAxLTcgMCAzLjUgMy41IDAgMCAxIDcgMHoiIGZpbGw9IiM0MTU1QkMiIHN0cm9rZT0iIzQxNTVCQyIvPjwvc3ZnPg==";
export { SvgPicTime as ReactComponent };